export const SALE_INFO_COLUMNS = [
    {
        header: 'Date',
        key: 'date',
        type: 'text',
    },
    {
        header: 'Book',
        key: 'book',
        type: 'text',
    },
    {
        header: 'Page',
        key: 'page',
        type: 'text',
    },
    {
        header: 'Price',
        key: 'price',
        type: 'text',
    },
    {
        header: 'NU#',
        key: 'nu',
        type: 'text',
    },
    {
        header: 'Ratio',
        key: 'ratio',
        type: 'title',
    },
    {
        header: 'Grantee',
        key: 'grantee',
        type: 'text',
    },
    {
        header: '',
        key: 'more',
        type: 'link',
    },
];

export const TAX_HISTORY_COLUMNS = [
    {
        header: 'Year',
        key: 'year',
        type: 'text',
    },
    {
        header: 'Prop Loc',
        key: 'prop_loc',
        type: 'text',
    },
    {
        header: 'Land',
        key: 'land_assmnt',
        type: 'text',
    },
    {
        header: 'Imp',
        key: 'imp',
        type: 'text',
    },
    {
        header: 'Total',
        key: 'total',
        type: 'text',
    },
    {
        header: 'Exemption',
        key: 'exemption',
        type: 'title',
    },
    {
        header: 'Assessed',
        key: 'assessed',
        type: 'text',
    },
    {
        header: 'Prop Class',
        key: 'prop_class',
        type: 'text',
    },
    {
        header: 'Additional Lots',
        key: 'additional_lots',
        type: 'text',
    },
    {
        header: 'Deductions',
        key: 'deductions',
        type: 'text',
    },
];

export const TAXES_COLUMNS = [
    {
        header: 'Year',
        key: 'year',
        type: 'text',
    },
    {
        header: 'Due Date',
        key: 'due_date',
        type: 'text',
    },
    {
        header: 'Type',
        key: 'type',
        type: 'text',
    },
    {
        header: 'Billed',
        key: 'billed',
        type: 'text',
    },
    {
        header: 'Balance',
        key: 'balance',
        type: 'text',
    },
    {
        header: 'Interest',
        key: 'interest',
        type: 'title',
    },
    {
        header: 'Total Due',
        key: 'total_due',
        type: 'text',
    },
    {
        header: 'Token ID',
        key: 'tx',
        type: 'text',
    },
    {
        header: 'Status',
        key: 'status',
        type: 'text',
    },
];

export const MENU = [
    { title: 'Schedule Closing' },
    { title: 'List for Sale' },
    { title: 'Assign Permissions' },
    { title: 'Fractionalize', path: '/fractionalize' },
    { title: 'Build Virtual DD Room', key: 'soon' },
    { title: 'File Permit', key: 'soon' },
];
